import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { ITheme, themed } from '../../themer';

interface IStyledAccordionTitleProps {
	showIsActive?: boolean;
}

export const StyledAccordionTitle = styled.button<
	IStyledAccordionTitleProps,
	ITheme
>`
	border: none;
	background-color: transparent;
	font-size: inherit;
	padding: ${themed(({ accordion }) => accordion.title.padding ?? '0')};
	color: ${themed<IStyledAccordionTitleProps>(({ color }, { showIsActive }) =>
		showIsActive ? color.highlight : color.text.default,
	)};
	font-family: ${themed(({ accordion }) => accordion.title.fontFamily)};
	justify-content: space-between;
	cursor: pointer;
	width: 100%;
	display: flex;
	align-items: center;
`;

const StyledIconContainer = styled.div<{ reverseIcon?: boolean }>`
	margin-left: 16px;
	display: flex;
	gap: 24px;
	svg {
		transform: rotate(0);
		transition: transform 0.3s ease;
	}

	${({ reverseIcon }) =>
		reverseIcon &&
		css`
			svg {
				transform: rotate(180deg);
				transition: transform 0.3s ease;
			}
		`}
`;

const StyledTitleWrapper = styled.div`
	width: 100%;
`;

interface IAccordionTitleProps {
	title: string | ReactNode;
	showIsActive?: boolean;
	isExpanded: boolean;
	onClick?(): void;
	icon?: ReactNode;
	reverseIcon?: ReactNode;
	id?: string;
}

export function AccordionTitle({
	title,
	showIsActive,
	isExpanded,
	onClick,
	icon,
	reverseIcon,
	id,
}: IAccordionTitleProps) {
	return (
		<StyledAccordionTitle
			type="button"
			showIsActive={showIsActive}
			onClick={onClick}
			aria-expanded={isExpanded}
			id={id}
		>
			<StyledTitleWrapper>{title}</StyledTitleWrapper>
			<StyledIconContainer reverseIcon={!!reverseIcon && !icon && isExpanded}>
				{icon || reverseIcon}
			</StyledIconContainer>
		</StyledAccordionTitle>
	);
}
